import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AutenticacionService} from './autenticacion.service';
import {SegmentoProducto} from '../_models/segmento-producto';

@Injectable({
  providedIn: 'root'
})
export class SegmentoProductosService {
  private rutServiciosRoles = AppSettings.rutServiciosAPL + '/api/segmentosProductos/';

  constructor(private httpClient: HttpClient, private autenticacionService: AutenticacionService) {
  }

  listado(): Observable<SegmentoProducto[]> {
    return this.httpClient.get(this.rutServiciosRoles).pipe(map(res => res as SegmentoProducto[]));
  }

  obtener(idSegmento: string): Observable<SegmentoProducto> {
    return this.httpClient.get(this.rutServiciosRoles + idSegmento).pipe(map(res => res as SegmentoProducto));
  }

  obtenerPorSegmento(idSegmento: string): Observable<SegmentoProducto[]> {
    return this.httpClient.get(this.rutServiciosRoles + 'segmento/' + idSegmento).pipe(map(res => res as SegmentoProducto[]));
  }

  agregar(segmento: SegmentoProducto): Observable<SegmentoProducto> {
    segmento.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post(this.rutServiciosRoles, segmento).pipe(map(res => res as SegmentoProducto));
  }

  actualizar(segmento: SegmentoProducto): Observable<any> {
    segmento.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.put(this.rutServiciosRoles, segmento).pipe(map(res => res));
  }
}
